import styled from 'styled-components';
import { Drawer } from 'ui';

export const StyledQualityMarkDrawer = styled(Drawer)`
  .file-uploader-title {
    font-weight: 400 !important;
  }
  .ant-drawer-header-title {
    flex-direction: row-reverse;
    .ant-drawer-close {
      margin-inline-end: 0;
      color: ${(props) => props.theme.black};
    }
  }
  .ant-drawer-footer {
    .footer {
      display: flex;
      align-items: center;
      gap: 20px;
      justify-content: flex-end;
      .ant-btn {
        border-radius: 3px;
      }
    }
  }

  .ant-drawer-body {
    .ant-input {
      border-radius: 3px;
    }
  }
`;
